import React from "react";

// redux
import { Provider } from 'react-redux';
import store from './store';

import CustomPricingContent from './CustomPricingContent';
const CustomPricing = () => {

  return (
    <Provider store={store}>
      <CustomPricingContent></CustomPricingContent>
    </Provider>
  );
};

export default CustomPricing;
